export default __webpack_public_path__ + "static/media/trash.7b727068.svg";